export const mediaItems = [
  {
    id: 1,
    title: '暗夜追踪',
    category: '悬疑剧',
    episode: '更新至第28集',
    heat: '9.6',
    tag: '热播中',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20movie%20scene%20with%20detective%20in%20dark%20city%20alley%20at%20night%2C%20mysterious%20noir%20atmosphere%20with%20neon%20lights%2C%20film%20grain%20texture%2C%20dramatic%20lighting%20and%20shadows%2C%20thriller%20aesthetic%2C%20warm%20amber%20and%20teal%20color%20tone&width=800&height=450&seq=media-card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '春风十里不如你',
    category: '都市情感',
    episode: '全集40集',
    heat: '9.4',
    tag: '口碑佳作',
    image: 'https://readdy.ai/api/search-image?query=romantic%20drama%20scene%20with%20couple%20walking%20in%20cherry%20blossom%20park%2C%20warm%20spring%20sunlight%20filtering%20through%20trees%2C%20soft%20dreamy%20cinematography%2C%20tender%20emotional%20moment%2C%20golden%20hour%20lighting%2C%20film%20aesthetic&width=800&height=450&seq=media-card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '星际迷途：新纪元',
    category: '科幻巨制',
    episode: '今日更新第15集',
    heat: '9.8',
    tag: '正在热播',
    image: 'https://readdy.ai/api/search-image?query=epic%20sci-fi%20space%20scene%20with%20astronaut%20standing%20on%20alien%20planet%20surface%2C%20massive%20nebula%20and%20distant%20galaxy%20in%20background%2C%20cinematic%20wide%20composition%2C%20dramatic%20lighting%2C%20film%20poster%20aesthetic%20with%20warm%20orange%20and%20deep%20teal%20tones&width=800&height=450&seq=media-card-03&orientation=landscape',
  },
];

export const cardItems = [
  {
    id: 1,
    title: '长安十二时辰 第二季',
    category: '古装悬疑',
    desc: '盛世长安暗流涌动，一桩离奇案件牵扯出朝堂与江湖的惊天秘密。',
    tag: '新剧上线',
    image: 'https://readdy.ai/api/search-image?query=ancient%20chinese%20city%20at%20dusk%20with%20traditional%20architecture%20and%20red%20lanterns%2C%20mysterious%20atmosphere%2C%20costume%20drama%20aesthetic%2C%20warm%20golden%20and%20crimson%20lighting%2C%20cinematic%20composition%2C%20historical%20fantasy%20mood&width=600&height=400&seq=card-item-01&orientation=landscape',
  },
  {
    id: 2,
    title: '深海危机',
    category: '灾难动作',
    desc: '深海钻井平台遭遇连环爆炸，幸存者们必须在绝境中寻找一线生机。',
    tag: '热门推荐',
    image: 'https://readdy.ai/api/search-image?query=deep%20ocean%20oil%20rig%20in%20stormy%20weather%20with%20dramatic%20waves%2C%20action%20disaster%20movie%20scene%2C%20intense%20red%20emergency%20lights%2C%20cinematic%20wide%20shot%2C%20dramatic%20contrast%20between%20dark%20sky%20and%20orange%20flames&width=600&height=400&seq=card-item-02&orientation=landscape',
  },
  {
    id: 3,
    title: '你好，旧时光',
    category: '青春校园',
    desc: '回到那个蝉鸣不止的夏天，一群少年的青春故事温暖开篇。',
    tag: '经典回顾',
    image: 'https://readdy.ai/api/search-image?query=sunny%20school%20campus%20with%20students%20under%20cherry%20blossom%20trees%2C%20youth%20drama%20scene%2C%20warm%20nostalgic%20summer%20atmosphere%2C%20soft%20golden%20light%2C%20Japanese%20and%20Chinese%20school%20aesthetic%2C%20gentle%20dreamy%20cinematography&width=600&height=400&seq=card-item-03&orientation=landscape',
  },
  {
    id: 4,
    title: '猎罪图鉴',
    category: '刑侦推理',
    desc: '画像师与刑警队长联手，用画笔还原真相，揭开每一桩悬案背后的隐情。',
    tag: '烧脑必看',
    image: 'https://readdy.ai/api/search-image?query=crime%20scene%20investigation%20room%20with%20forensic%20sketch%20artist%20drawing%20portrait%2C%20mysterious%20moody%20lighting%2C%20detective%20drama%20aesthetic%2C%20warm%20desk%20lamp%20contrast%20with%20dark%20room%2C%20film%20noir%20composition&width=600&height=400&seq=card-item-04&orientation=landscape',
  },
  {
    id: 5,
    title: '山河令之续',
    category: '武侠玄幻',
    desc: '江湖风云再起，侠义与情仇交织，一段跨越山河的传奇征程。',
    tag: '爆款续作',
    image: 'https://readdy.ai/api/search-image?query=martial%20arts%20heroes%20standing%20on%20mountain%20cliff%20at%20sunset%2C%20flowing%20robes%20in%20wind%2C%20epic%20chinese%20fantasy%20landscape%20with%20mist%20and%20snow%20capped%20peaks%2C%20warm%20golden%20light%2C%20wuxia%20cinematic%20aesthetic&width=600&height=400&seq=card-item-05&orientation=landscape',
  },
  {
    id: 6,
    title: '白夜追凶 第三季',
    category: '悬疑犯罪',
    desc: '双胞胎身份之谜持续升级，灭门惨案真相逐渐浮出水面。',
    tag: '万众期待',
    image: 'https://readdy.ai/api/search-image?query=dual%20identity%20thriller%20with%20man%20looking%20at%20mirror%20reflection%20in%20dim%20room%2C%20mysterious%20atmosphere%2C%20split%20personality%20concept%2C%20film%20noir%20lighting%20with%20shadows%2C%20psychological%20thriller%20aesthetic%2C%20cold%20blue%20and%20warm%20amber%20contrast&width=600&height=400&seq=card-item-06&orientation=landscape',
  },
];

export const carouselItems = [
  {
    id: 1,
    title: '2026暑期档必看指南',
    subtitle: '重磅大片扎堆上映',
    desc: '涵盖动作、悬疑、喜剧、科幻等多类型，为你梳理暑期最值得追的15部新片，一部不落全在这里。',
    label: '编辑精选',
    image: 'https://readdy.ai/api/search-image?query=summer%20movie%20theater%20interior%20with%20vibrant%20film%20posters%20on%20wall%2C%20popcorn%20and%20tickets%2C%20warm%20golden%20cinema%20lighting%2C%20excited%20audience%20silhouettes%2C%20blockbuster%20season%20aesthetic%2C%20rich%20red%20and%20gold%20color%20palette&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '国产悬疑剧巅峰对决',
    subtitle: '谁才是真正的年度剧王',
    desc: '今年国产悬疑剧迎来井喷，从刑侦到心理，从古代到现代，十部高分悬疑剧全方位对比评测。',
    label: '深度盘点',
    image: 'https://readdy.ai/api/search-image?query=suspense%20thriller%20movie%20scene%20with%20detective%20examining%20evidence%20board%20with%20red%20strings%20connecting%20photos%2C%20dark%20moody%20room%20with%20single%20overhead%20lamp%2C%20crime%20investigation%20aesthetic%2C%20dramatic%20shadows%2C%20cinematic%20noir%20style&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '古装剧服化道大赏',
    subtitle: '从细节看制作诚意',
    desc: '盘点近年古装剧中的精美服饰与场景设计，从唐朝到明朝，感受不同年代的美学风华与文化底蕴。',
    label: '视觉盛宴',
    image: 'https://readdy.ai/api/search-image?query=traditional%20chinese%20costume%20drama%20behind%20scenes%20with%20elaborate%20historical%20robes%20and%20headdresses%20displayed%2C%20rich%20silk%20fabrics%20with%20embroidery%2C%20warm%20studio%20lighting%2C%20artistic%20composition%2C%20gold%20and%20crimson%20color%20scheme&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '治愈系温情电影合集',
    subtitle: '给疲惫生活的一剂温柔',
    desc: '精选十部温暖人心的治愈系电影，从亲情到友情，从宠物到成长，每一部都能让你在深夜里找到慰藉。',
    label: '情感推荐',
    image: 'https://readdy.ai/api/search-image?query=warm%20and%20cozy%20living%20room%20scene%20with%20person%20watching%20movie%20under%20soft%20blanket%2C%20gentle%20warm%20lamp%20light%2C%20cat%20curled%20up%20nearby%2C%20comforting%20atmosphere%2C%20golden%20hour%20tones%2C%20feel-good%20cinematic%20style&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '科幻迷不可错过的年度片单',
    subtitle: '想象力无界的视觉之旅',
    desc: '从硬核科幻到软科幻，从太空歌剧到赛博朋克，这份片单涵盖科幻电影的所有分支，满足你对未来的所有想象。',
    label: '类型盘点',
    image: 'https://readdy.ai/api/search-image?query=futuristic%20cyberpunk%20cityscape%20with%20neon%20signs%20and%20flying%20vehicles%2C%20dense%20urban%20sci-fi%20environment%2C%20dramatic%20purple%20and%20orange%20sky%2C%20cinematic%20wide%20angle%2C%20blade%20runner%20inspired%20aesthetic%2C%20warm%20neon%20ambient%20light&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
  {
    id: 6,
    title: '经典港片回顾特辑',
    subtitle: '那些年我们追过的港片',
    desc: '从警匪到武侠，从喜剧到爱情，重温香港电影的黄金年代，那些至今仍让人热血沸腾的经典名场面。',
    label: '怀旧经典',
    image: 'https://readdy.ai/api/search-image?query=classic%20Hong%20Kong%20film%20scene%20with%20neon%20lit%20street%20at%20night%2C%20vintage%20cinema%20aesthetic%2C%20kung%20fu%20action%20pose%20silhouette%2C%20retro%201990s%20atmosphere%2C%20warm%20nostalgic%20color%20grading%2C%20iconic%20city%20skyline&width=800&height=500&seq=carousel-06&orientation=landscape',
  },
];

export const commentItems = [
  {
    id: 1,
    name: '追剧小王子',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20man%20portrait%2C%20casual%20style%2C%20friendly%20smile%2C%20warm%20natural%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    date: '2026-07-28',
    content: '木瓜影视真的是我见过最好的在线观看平台！之前用别的网站总是各种弹窗广告和卡顿，在这里直接看高清视频，一点都不缓冲，追剧体验太好了。最新电视剧更新速度也很快，强烈推荐！',
    likes: 328,
  },
  {
    id: 2,
    name: '电影爱好者阿琳',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20woman%20portrait%2C%20stylish%20casual%20look%2C%20warm%20genuine%20smile%2C%20soft%20natural%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot%20photography&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 5,
    date: '2026-07-26',
    content: '网页看视频真的太方便了，不用下载App也不用注册，点开就能看。画质清晰度和流畅度完全超出预期，而且片库更新得特别勤，基本上热播剧当天就能在木瓜影视找到，已经成为我的追剧首选。',
    likes: 256,
  },
  {
    id: 3,
    name: '深夜刷剧人',
    avatar: 'https://readdy.ai/api/search-image?query=middle%20aged%20Chinese%20man%20portrait%2C%20relaxed%20expression%2C%20glasses%2C%20warm%20friendly%20smile%2C%20soft%20studio%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot%20photography&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 4,
    date: '2026-07-25',
    content: '即点即播这个体验是真的好，在公司午休摸鱼看一会电视剧也不用等缓冲。分类索引做得也很清晰，找片效率很高。希望后续能增加更多经典老剧的资源，有些怀旧剧集在别的地方已经找不到了。',
    likes: 189,
  },
];

export const topicItems = [
  { id: 1, name: '暑期档', heat: '128万讨论' },
  { id: 2, name: '悬疑剧天花板', heat: '96万讨论' },
  { id: 3, name: '古装剧服化道', heat: '83万讨论' },
  { id: 4, name: '科幻片推荐', heat: '71万讨论' },
  { id: 5, name: '高分国产剧', heat: '65万讨论' },
  { id: 6, name: '新剧开播日历', heat: '58万讨论' },
  { id: 7, name: '港片回忆杀', heat: '52万讨论' },
  { id: 8, name: '治愈系电影', heat: '47万讨论' },
  { id: 9, name: '刑侦剧大盘点', heat: '41万讨论' },
  { id: 10, name: '青春校园', heat: '36万讨论' },
];

export const appEntry = {
  title: '随时随地，畅享高清观影',
  subtitle: '木瓜影视移动版已覆盖 iOS 与 Android 平台，手机看视频同样高清不缓冲，同步桌面端全部片库。',
  features: ['离线缓存，无网也能看', '小窗播放，边看边聊', '投屏到电视，大屏更过瘾', '夜间模式，护眼追剧'],
  image: 'https://readdy.ai/api/search-image?query=modern%20smartphone%20holding%20in%20hand%20displaying%20movie%20streaming%20app%20interface%2C%20dark%20mode%20UI%20with%20movie%20posters%2C%20clean%20minimal%20design%2C%20warm%20ambient%20background%20with%20bokeh%20lights%2C%20tech%20lifestyle%20photography%2C%20cinematic%20mood&width=600&height=800&seq=app-entry&orientation=portrait',
};

export const contactEntry = {
  title: '投稿与合作',
  subtitle: '如果你有好的影视推荐内容，或希望与木瓜影视进行商务合作，欢迎通过以下方式联系我们。',
  email: 'contact@mugua.movie',
  tips: ['内容投稿', '版权合作', '广告投放', '友情链接'],
};

export const rankingItems = [
  { id: 1, rank: 1, title: '暗夜追踪', category: '悬疑剧', heat: '9.6', trend: 'up', change: '+2' },
  { id: 2, rank: 2, title: '星际迷途：新纪元', category: '科幻巨制', heat: '9.5', trend: 'up', change: '+1' },
  { id: 3, rank: 3, title: '春风十里不如你', category: '都市情感', heat: '9.4', trend: 'same', change: '-' },
  { id: 4, rank: 4, title: '长安十二时辰 第二季', category: '古装悬疑', heat: '9.3', trend: 'up', change: '+3' },
  { id: 5, rank: 5, title: '猎罪图鉴', category: '刑侦推理', heat: '9.1', trend: 'down', change: '-1' },
  { id: 6, rank: 6, title: '山河令之续', category: '武侠玄幻', heat: '9.0', trend: 'up', change: '+4' },
];

export const indexItems = [
  { id: 1, name: '悬疑推理', count: '156部', icon: 'ri-search-eye-line' },
  { id: 2, name: '古装历史', count: '203部', icon: 'ri-building-2-line' },
  { id: 3, name: '都市情感', count: '189部', icon: 'ri-heart-line' },
  { id: 4, name: '科幻奇幻', count: '127部', icon: 'ri-rocket-line' },
  { id: 5, name: '动作冒险', count: '174部', icon: 'ri-sword-line' },
  { id: 6, name: '喜剧综艺', count: '142部', icon: 'ri-emotion-laugh-line' },
  { id: 7, name: '纪录纪实', count: '98部', icon: 'ri-camera-line' },
];

export const aboutEntry = {
  title: '关于木瓜影视',
  paragraphs: [
    '木瓜影视成立于2023年，致力于为广大影视爱好者打造一个免费、便捷、高品质的在线观看平台。我们深知追剧看片的快乐不容打扰——没有复杂的注册流程，没有烦人的弹窗广告，没有令人抓狂的缓冲等待，打开网页就能直接观看最新电视剧和电影。',
    '目前木瓜影视已收录超过2000部高清影视资源，涵盖悬疑、古装、都市、科幻、动作、喜剧、纪录片等全品类内容。我们的内容团队每天持续更新片库，确保热播剧和最新电影能够在第一时间与观众见面。同时，我们也在不断优化播放技术，支持多种清晰度自适应切换，真正做到高清不缓冲的流畅观影体验。',
    '木瓜影视的愿景是让每一个人都能轻松享受影视世界的精彩。无论你是在通勤路上、午休间隙还是深夜独处，打开木瓜影视，总有一部好剧在等你。',
  ],
};

export const featureItems = [
  { id: 1, icon: 'ri-flashlight-line', title: '即点即播', desc: '无需下载客户端，无需注册账号，打开网页点击播放按钮即可观看，零等待体验。' },
  { id: 2, icon: 'ri-4k-line', title: '高清画质', desc: '支持多档清晰度自适应切换，根据网络状况智能匹配最优画质，最高可达超清蓝光级别。' },
  { id: 3, icon: 'ri-speed-up-line', title: '极速加载', desc: '采用全球CDN加速节点分发，全国范围内均可享受秒开秒播的流畅观影体验，告别缓冲焦虑。' },
  { id: 4, icon: 'ri-device-line', title: '多端同步', desc: '桌面端、平板、手机多设备无缝切换，观影进度自动同步，随时随地继续追剧。' },
];

export const faqItems = [
  {
    id: 1,
    question: '木瓜影视真的完全免费在线观看吗？需要注册账号吗？',
    answer: '是的，木瓜影视完全免费在线观看，无需注册账号。只需打开网页，选择你想看的电视剧或电影，点击播放按钮即可直接开始观影。我们没有任何隐藏收费，也不会在播放中途插入付费弹窗。',
  },
  {
    id: 2,
    question: '为什么在木瓜影视网页看视频可以做到高清不缓冲？',
    answer: '木瓜影视采用了先进的视频编码压缩技术和全球CDN内容分发网络，能够根据用户的网络状况自动调整清晰度档位，即使在4G网络环境下也能流畅播放高清画质。同时我们的服务器部署了智能预加载机制，提前缓存后续内容，确保播放过程中不会出现卡顿缓冲。',
  },
  {
    id: 3,
    question: '木瓜影视的电视剧和电影更新速度快吗？新剧什么时候上线？',
    answer: '我们的内容团队每天跟踪最新电视剧和电影的播出动态，热门剧集通常在播出后的数小时内即可在木瓜影视上线。电影方面，院线下映后的高清版本也会尽快收录入库。你可以通过关注我们的"最新动态"栏目获取每日更新通知。',
  },
  {
    id: 4,
    question: '在木瓜影视观看视频会产生流量费用吗？支持离线下载吗？',
    answer: '在线观看视频会消耗网络流量，如果使用移动数据观看，建议留意流量使用情况。目前桌面端暂不支持离线下载功能，但你可以在移动端App中使用离线缓存功能，提前在有Wi-Fi的环境下缓存好想看的剧集，之后无网络也能观看。',
  },
];

export const updateItems = [
  { id: 1, date: '2026-07-31', label: '新剧上线', title: '《暗夜追踪》第29-30集已更新，案件进入白热化阶段' },
  { id: 2, date: '2026-07-30', label: '片库更新', title: '暑期档专题页面上线，15部重磅新片一站式收录' },
  { id: 3, date: '2026-07-28', label: '功能优化', title: '播放器升级至v3.2版本，新增智能画质增强和记忆续播功能' },
  { id: 4, date: '2026-07-26', label: '新剧上线', title: '《星际迷途：新纪元》第16集抢先上线，特效全面升级' },
  { id: 5, date: '2026-07-25', label: '片库更新', title: '新增经典港片专区，收录80-90年代港产片代表作超百部' },
  { id: 6, date: '2026-07-22', label: '社区动态', title: '木瓜影视用户突破500万，感谢每一位热爱观影的你们' },
  { id: 7, date: '2026-07-20', label: '新剧上线', title: '《白夜追凶 第三季》定档8月15日，独家预告片抢先发布' },
  { id: 8, date: '2026-07-18', label: '功能优化', title: '分类索引页面重构，新增按年代、评分、地区三维筛选功能' },
];